"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Docs = void 0;
const class_validator_1 = require("class-validator");
const Docs = (values) => (target, key) => {
    let constraints;
    if ('defaultValue' in values) {
        constraints = [values.defaultValue, values.description, true];
    }
    else {
        constraints = [values.example, values.description, false];
    }
    (0, class_validator_1.registerDecorator)({
        target: target.constructor,
        propertyName: key.toString(),
        name: 'Docs',
        validator: { validate: () => true },
        constraints,
    });
};
exports.Docs = Docs;
